// removed by extract-text-webpack-plugin
module.exports = {"root":"SummaryCard__root--1IB_B","image":"SummaryCard__image--FZmeA","bounce":"SummaryCard__bounce--2zSpK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/SummaryCard/SummaryCard.css
// module id = ./src/components/Library/SummaryCard/SummaryCard.css
// module chunks = 4